import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    if (!sid) { navigate("/"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data.user);
        // Clear the hash
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user }, replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] text-zinc-400" data-testid="auth-callback">
      <div className="text-sm">Signing you in…</div>
    </div>
  );
}
